import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { dashboardUserApi } from '~/utils/api';

export const getApiKeys = async () =>
  dashboardUserApi.get<RcInstanceDTO.AccessCredentials[]>('/apikeys');

export const getApiKeyById = async (id: string) =>
  dashboardUserApi.get<RcInstanceDTO.AccessCredentialsWithSecret>(`/apikeys/${id}`);

export const createApiKey = async (name: string) =>
  dashboardUserApi.post<RcInstanceDTO.AccessCredentials>('/apikeys', {
    name,
  });

export const deleteApiKeyById = async (id: string) =>
  dashboardUserApi.delete<RcInstanceDTO.AccessCredentials>(`/apikeys/${id}`);

export const editApiKey = async (id: string, apiKey: Partial<RcInstanceDTO.AccessCredentials>) =>
  dashboardUserApi.put<RcInstanceDTO.AccessCredentials>(`/apikeys/${id}`, { ...apiKey });
